import { Button, Modal, Space, Tag } from "antd";
import { arrayMoveImmutable } from "array-move";
import CustomTable from "components/CustomTable";
import { useState } from "react";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import { useDeleteProjectQuestion, useReorderProjectQuestions } from "features/ProjectType/data/hooks";
import { ProjectTypeState, showProjectTypeError } from "features/ProjectType/presentation/components/ProjectTypeState";
import QuestionFormModal, { ANSWER_TYPE_LABEL } from "./QuestionFormModal";
const Handle = SortableHandle(() => (
  <span aria-label="Kéo câu hỏi" style={{ cursor: "grab" }}>
    ⋮⋮
  </span>
));
const Row = SortableElement((props) => <tr {...props} />);
const Body = SortableContainer((props) => <tbody {...props} />);
export default function QuestionTab({ query, projectTypeId, projectTypeName }) {
  const [editing, setEditing] = useState(null);
  const remove = useDeleteProjectQuestion();
  const reorder = useReorderProjectQuestions();
  const rows = query.data || [];
  const saving = reorder.loading || remove.loading;
  const onSortEnd = async ({ oldIndex, newIndex }) => {
    if (saving || oldIndex === newIndex) return;
    const previous = [...rows];
    const next = arrayMoveImmutable(previous, oldIndex, newIndex).map((row, index) => ({
      ...row,
      displayOrder: index + 1,
    }));
    query.setData(next);
    try {
      await reorder.mutate(
        projectTypeId,
        next.map((row) => row.id)
      );
      await query.refetch();
    } catch (error) {
      query.setData(previous);
      showProjectTypeError(error);
    }
  };
  const deleteRow = (row) =>
    Modal.confirm({
      title: "Phiếu đã gửi vẫn giữ câu trả lời cũ.",
      okText: "Xóa",
      cancelText: "Hủy",
      onOk: async () => {
        try {
          await remove.mutate(row.id);
          await query.refetch();
        } catch (error) {
          showProjectTypeError(error);
        }
      },
    });
  const columns = [
    { title: "", width: 40, render: () => <Handle /> },
    { title: "THỨ TỰ", width: 90, dataIndex: "displayOrder" },
    {
      title: "TÊN CÂU HỎI",
      dataIndex: "label",
      render: (label, row) => (
        <Space>
          {label}
          {row.isMainQuantity && <Tag color="blue">Số lượng chính</Tag>}
        </Space>
      ),
    },
    { title: "KIỂU TRẢ LỜI", dataIndex: "answerType", render: (value) => ANSWER_TYPE_LABEL[value] },
    { title: "BẮT BUỘC", dataIndex: "isRequired", render: (value) => (value ? "Có" : "Không") },
    { title: "ĐƠN VỊ / LỰA CHỌN", render: (_, row) => row.unit || row.options?.join(" · ") || "—" },
    {
      title: "HÀNH ĐỘNG",
      width: 150,
      render: (_, row) => (
        <Space>
          <Button type="link" disabled={saving} onClick={() => setEditing(row)}>
            Sửa
          </Button>
          <Button danger type="link" disabled={saving} onClick={() => deleteRow(row)}>
            Xóa
          </Button>
        </Space>
      ),
    },
  ];
  const DraggableBody = (props) => (
    <Body {...props} useDragHandle onSortEnd={onSortEnd} helperClass="project-type-drag-row" />
  );
  const DraggableRow = (props) => (
    <Row {...props} disabled={saving} index={rows.findIndex((row) => row.id === props["data-row-key"])} />
  );
  const error = [remove.error, reorder.error].find((value) => value?.code === "FORBIDDEN") || query.error;
  return (
    <>
      <p>
        Câu hỏi hiện trong khối 'Thông tin {projectTypeName}' trên form app. Thay đổi chỉ áp dụng cho phiếu gửi sau khi
        lưu.
      </p>
      <div className="project-type-toolbar">
        <span />
        <Button type="primary" disabled={saving} onClick={() => setEditing({})}>
          + Thêm câu hỏi
        </Button>
      </div>
      <ProjectTypeState loading={query.loading} data={query.data} error={error} refetch={query.refetch}>
        <CustomTable
          rowKey="id"
          dataSource={rows}
          columns={columns}
          pagination={false}
          style={{ opacity: saving ? 0.5 : 1 }}
          components={{ body: { wrapper: DraggableBody, row: DraggableRow } }}
          locale={{ emptyText: `Loại này chưa có câu hỏi riêng. Form app sẽ ẩn khối Thông tin ${projectTypeName}.` }}
        />
      </ProjectTypeState>
      {editing && (
        <QuestionFormModal
          current={editing.id ? editing : undefined}
          projectTypeId={projectTypeId}
          nextOrder={Math.max(0, ...rows.map((row) => row.displayOrder)) + 1}
          onSaved={query.refetch}
          onClose={() => setEditing(null)}
        />
      )}
    </>
  );
}
